import React, { PropTypes } from "react"
import { PlusIcon } from "../../core/icons"
import { Link } from "react-router-dom"
import { Button, Icon } from "antd"
import { connect } from "react-redux"
import "./EmptyState.css"

const EmptyState = connect(state => state)(props => {
  const fetchingOverride = props.isFetching == null ? false : props.isFetching
  const isFetching = fetchingOverride || props.models.user.isFetching
  return (
    <div
      className={"EmptyState" + " " + props.className}
      style={{ display: "flex-column", alignItems: "center" }}
    >
      {isFetching && (
        <Icon
          type="loading"
          style={{ fontSize: "24px", color: "#31b59f", fontWeight: "600" }}
        />
      )}
      {!isFetching && (
        <div>
          {props.icon && (
            <props.icon
              color={props.iconColor || "#96a2c2"}
              width={props.iconWidth || "40"}
              height={props.iconHeight || "40"}
            />
          )}
          <h3>{props.title}</h3>
          {props.buttonLink && (
            <Link to={props.buttonLink}>
              <Button type="primary" icon={props.buttonIcon || "plus"}>
                {props.buttonText}
              </Button>
            </Link>
          )}
          {props.onClick &&
            props.buttonText && (
              <Button
                type="primary"
                onClick={props.onClick}
                icon={props.buttonIcon || "plus"}
              >
                {props.buttonText}
              </Button>
            )}
        </div>
      )}
    </div>
  )
})

export default EmptyState



// WEBPACK FOOTER //
// ./src/core/components/EmptyState.js